// extracted by mini-css-extract-plugin
export default {"widget":"WorkspaceProvider-module_widget__rTHm9","border":"WorkspaceProvider-module_border__ih95t","blink":"WorkspaceProvider-module_blink__wWBAu"};